$(function () {
    if ($('#EnrolmentDetailsForm').length > 0) {
        $("#btnEdixt").on('click', function () {

            var lang = jsEDLang;

            var baseURLpp = jsBaseURLpp;
            var ParentIamId = jsParentIamId;

            var printURL = baseURLpp + '/' + lang + '/Admin/User/GetRequestList/?ClientId=' + ParentIamId;


            if (printURL != '') {
                window.open(printURL, "_blank");
            }
        });

        $(document).on('click', '.PrintCFAInstructions', function (e) {

            var self = $(this);
            oper = self.data('oper');
            licence = self.data('licence');


            if (location.href.indexOf('/en/') > 0) {
                url = location.href.split('/en/')[0] + '/en/license/manageenrolment/CFAInstructions/' + jsOper + '/' + jsLicence + '/' + jsEnrolId + '/?expirydate='+jsExpiredBenefitDate +'&fname='+ jsChildFirstName + '&lname='+ jsChildLastName ;
            } else {
                url = location.href.split('/fr/')[0] + '/fr/license/manageenrolment/CFAInstructions/' + jsOper + '/' + jsLicence + '/' + jsEnrolId + '/?expirydate=' + jsExpiredBenefitDate + '&fname=' + jsChildFirstName + '&lname=' + jsChildLastName;
            }

            console.log(url);

            $.ajax({
                url: url,
                method: 'POST',
                contentType: false,
                processData: false,
                success: function (res) {
                    //window.location.href = url;
                    window.open(url, "_blank");
                },
                error: function () {
                    window.location.href = url;
                }
            });
        });


        var oper;
        var licence;
        $(document).on('click', '.btnCancel', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var self = $(this);
            oper = self.data('oper');
            licence = self.data('licence');

            $("#CancelModal").modal();
        });

        $(document).on('click', '.btnCancel', function (e) {
            var url = '';
            var self = $(this);
            oper = self.data('oper');
            licence = self.data('licence');

            if (location.href.indexOf('/en/') > 0) {
                url = location.href.split('/en/')[0] + '/en/license/manageenrolment/enrolmentlist/' + oper + '/' + licence + '/';
            } else {
                url = location.href.split('/fr/')[0] + '/fr/license/manageenrolment/enrolmentlist/' + oper + '/' + licence + '/';
            }

            $.ajax({
                url: url,
                method: 'POST',
                contentType: false,
                processData: false,
                success: function (res) {
                    window.location.href = url;
                },
                error: function () {
                    window.location.href = url;
                }
            });
        });

        $(document).on('click', '.btnCancelReturn', function (e) {
            var url = '';
            var self = $(this);
            url = self.data('oper');

            $.ajax({
                url: url,
                method: 'POST',
                contentType: false,
                processData: false,
                success: function (res) {
                    window.location.href = url;
                },
                error: function () {
                    window.location.href = url;
                }
            });
        });


        var lang = jsEDLang;

        if ($("#ViewAsOfDate").val() === "0001-01-01") {
            $("#ViewAsOfDate").val("");
        }
        $(".register-child-page").show();

        function load() {

            var today = new Date();

            console.log("ViewAsOfDate: " + $("#ViewAsOfDate").val());

            if (!$("#ViewAsOfDate").val()) {

                var dd = String(today.getDate()).padStart(2, '0');
                var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
                var yyyy = today.getFullYear();

                today = yyyy + '-' + mm + '-' + dd;
                $("#ViewAsOfDate").val(today)
            }
            var changedt = !$("#ViewAsOfDate").val() ? today : $("#ViewAsOfDate").val();

            console.log("a" + changedt)

            if (location.href.indexOf('/en/') > 0) {
                url = location.href.split('/en/')[0] + '/en/License/ManageEnrolment/EnrolmentDetails/' + jsOper + '/' + jsLicence + '/' + jsEnrolId + '/?viewasofdate=changedt';
            } else {
                url = location.href.split('/fr/')[0] + '/fr/License/ManageEnrolment/EnrolmentDetails/' + jsOper + '/' + jsLicence + '/' + jsEnrolId + '/?viewasofdate=changedt';
            }

            //var url = '@Html.Raw(Url.Action("EnrolmentDetails", "ManageEnrolment", new { oper = ViewContext.RouteData.Values["oper"].ToString(), license=Model.LicenseNumber.ToDisplayInt(), id=Model.EnrollmentId.ToDisplayInt(), } )) '

            url = url.replace('changeme', $(".filterx").val())
            url = url.replace('changedt', changedt);

            console.log(url);
            //location.href = url;

            $.ajax({
                url: url,
                method: 'GET',
                contentType: false,
                processData: false,
                success: function (res) {
                    window.location.href = url;
                },
                error: function () {
                    window.location.href = url;
                }
            });

        };

        function HandleLoad() {
            load()

        }
        $(function () {
            var dt = jsViewAsOfDate;
            if (dt == "") {
                var today = new Date();
                var dd = String(today.getDate()).padStart(2, '0');
                var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
                var yyyy = today.getFullYear();

                today = yyyy + '-' + mm + '-' + dd;
                $("#ViewAsOfDate").val(today)
            }
            else {
                $("#ViewAsOfDate").val(dt);
            }

        });

        $(".datepicker.asofdate").datetimepicker({
            viewMode: "days",
            format: "YYYY-MM-DD",
            locale: lang + "-ca",
            keepOpen: false,
            minDate: jsEarliestDate,
            defaultDate: false
        });

        $(".datepicker.asofdate").on('blur', function () {
            HandleLoad();
        });

        $(".datepicker.enddate").datetimepicker({
            viewMode: "days",
            format: "YYYY-MM-DD",
            locale: lang + "-ca",
            keepOpen: false,
            minDate: jsCFAMinEndDate,
            maxDate: jsNow,
            defaultDate: false
        });


        $(".EnrAckSbt").on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var id = $(this).data('id');

            var chkAck = $('.EnrAck[data-id="' + id + '"]:checked').length;

            if (chkAck == 0) {
                $(".EnrAckErr[data-id=" + id + "]").removeClass("d-none");
                canSave = false;
            } else {
                $(".EnrAckErr[data-id=" + id + "]").addClass("d-none");
                window.location = $(this).data("href");
            }
             
        });

        $(".btnSaveAck").on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var id = $(this).data('id');
            var processId = $(this).data('processingid');
            var canSave = true;
            var showAckMsg = $(this).data('showcfaadjustmentmsg');

            console.log(id);
            console.log(showAckMsg);

            $(".iscurrentprocess[data-id=" + processId + "]").val('True');

            var chkAck = $('.chkAck[data-id="' + processId + '"]:checked').length;
            var chkAdjustment = $('.chkAdjustment[data-id="' + processId + '"]:checked').length;
            var chkVerified = $('.chkVerified[data-id="' + processId + '"]:checked').length;
            var fullname = $(".fullname[data-id=" + processId + "]").val();

            if (chkAck == 0) {
                $(".ackerror[data-id=" + processId + "]").removeClass("d-none");
                canSave = false;
            }
            else {
                $(".ackerror[data-id=" + processId + "]").addClass("d-none");
            }

            if (showAckMsg == "True") {
                if (chkAdjustment == 0) {
                    $(".adjustmenterror[data-id=" + processId + "]").removeClass("d-none");
                    canSave = false;
                }
                else {
                    $(".adjustmenterror[data-id=" + processId + "]").addClass("d-none");
                }
            }



            if (chkVerified == 0) {
                $(".verifiederror[data-id=" + processId + "]").removeClass("d-none");
                canSave = false;
            }
            else {
                $(".verifiederror[data-id=" + processId + "]").addClass("d-none");
            }

            if (fullname == "") {
                $(".signatureerror[data-id=" + processId + "]").removeClass("d-none");
                canSave = false;
            }
            else {
                $(".signatureerror[data-id=" + processId + "]").addClass("d-none");
            }


            $("#AckdCFAEnrolmentId").val(id);
            $("#ShowCFAAdjustmentMsg").val(showAckMsg);

            if (canSave)
            {
                $('#EnrolmentDetailsForm')[0].submit();
            }
                    
        });

        
        $("#btnSaveCfaBenefit").on("click", function () {

            $(".cfaEndDateError").addClass("d-none");
            $(".cfaTerminationReasonError").addClass("d-none");

            var dateStr = $("#newCfaEndDate").val();
            var terminationReasonCd = $("#TerminationReasonCd").val();

            if (!Date.parse(dateStr)) {
                $("#CfaEndDateInvalid").removeClass("d-none");
                return false;
            }
            var dateSplit = $("#newCfaEndDate").val().split("-");
            var date = new Date(dateSplit[0], parseInt(dateSplit[1]) - 1, dateSplit[2]);

            // we need to put some validations here in case they circumvent the date picker's settings or something
            var minDateSplit = jsCFAMinEndDate.split("-");
            var minEndDate = new Date(minDateSplit[0], parseInt(minDateSplit[1]) - 1, minDateSplit[2]);
            var maxDateSplit = jsCFALatestStartDate.split("-");
            var maxStartDate = new Date(maxDateSplit[0], parseInt(maxDateSplit[1]) - 1, maxDateSplit[2]);
            var nowSplit = jsNow.split("-");
            var now = new Date(nowSplit[0], nowSplit[1], nowSplit[2]);
            
            var isValid = true;
            if (date > now) {
                $("#CfaEndDateFutureError").removeClass("d-none");
                isValid = false;
            } else if(date <= maxStartDate) {
                $("#CfaEndDateFirstDayError").removeClass("d-none");
                isValid = false;
            } else if(date <= minEndDate) {
                $("#CfaEndDateFeeSubsidyError").removeClass("d-none");
                isValid = false;
            }

            if (terminationReasonCd == "") {
                $(".cfaTerminationReasonError").removeClass("d-none");
                isValid = false;
            }

            if(!isValid) {
                return false;
            }

            var formData = new FormData();

            formData.append('newEndDate', dateStr);
            formData.append('terminationReasonCd', terminationReasonCd);

            var url = '';
            if (location.href.indexOf('/en/') > 0) {
                url = location.href.split('/en/')[0] + '/en/License/ManageEnrolment/UpdateCfaEndDate/';
            } else {
                url = location.href.split('/fr/')[0] + '/fr/License/ManageEnrolment/UpdateCfaEndDate/';
            }

            $("#divUMSpinner").removeClass("d-none");
            $("#btnSaveCfaBenefit").prop("disabled", true);

            $.ajax({
                url: url + jsOper + "/" + jsLicence + "/" + jsLatestCfaId,
                method: 'POST',
                contentType: false,
                processData: false,
                data: formData,
                success: function (res) {
                    window.location.reload();
                }
            });
        });

        $("select[id='TerminationReasonCd']").on('change', function () {

            $(".cfaTerminationReasonError").addClass("d-none");
        });

        $(".chkReviewed").on('click', function () {
            $("#IsReviewed").val(true); 

            if ($(".chkReviewed").is(":checked")) {
                $(".chkReviewedSubmit").prop("disabled", false);
            } else {
                $(".chkReviewedSubmit").prop("disabled", true);
                
            }
        });
        
        $(".chkReviewedSubmit").on('click', function () {           

            var today = new Date();

            if (!$("#ViewAsOfDate").val()) {

                var dd = String(today.getDate()).padStart(2, '0');
                var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
                var yyyy = today.getFullYear();

                today = yyyy + '-' + mm + '-' + dd;
                $("#ViewAsOfDate").val(today)
            }
            var changedt = !$("#ViewAsOfDate").val() ? today : $("#ViewAsOfDate").val();
            console.log($("#IsReviewed").val());

            if (location.href.indexOf('/en/') > 0) {
                url = location.href.split('/en/')[0] + '/en/License/ManageEnrolment/EnrolmentDetails/' + jsOper + '/' + jsLicence + '/' + jsEnrolId + '/?viewasofdate=changedt&reviewed=1';
            } else {
                url = location.href.split('/fr/')[0] + '/fr/License/ManageEnrolment/EnrolmentDetails/' + jsOper + '/' + jsLicence + '/' + jsEnrolId + '/?viewasofdate=changedt&reviewed=1';
            }

        //var url = '@Html.Raw(Url.Action("EnrolmentDetails", "ManageEnrolment", new { oper = ViewContext.RouteData.Values["oper"].ToString(), license=Model.LicenseNumber.ToDisplayInt(), id=Model.EnrollmentId.ToDisplayInt(), viewasofdate="changedt", reviewed="1"} )) '

            url = url.replace('changeme', $(".filterx").val())
            url = url.replace('changedt', changedt);

        console.log(url);

            $.ajax({
                url: url,
                method: 'GET',
                contentType: false,
                processData: false,
                success: function (res) {
                    window.location.href = url;
                },
                error: function () {
                    window.location.href = url;
                }
            });

        //location.href = url;
        });
    }
}); 